import React, { useState, useEffect, Fragment } from 'react';
import axios from 'axios';
import classNames from 'classnames/bind';
import Slider from 'react-slick';
import stylesSlider from 'slick-carousel/slick/slick.css';

import { withErrorBoundary } from 'containers/ErrorBoundary';
import { withCountryContext } from 'containers/withCountryContext';

import { backendUrl, basicAuth } from 'utils/constantsHelper';
import { langCodeTA } from 'utils/currentLanguage';
import { getSettings } from 'utils/sliderSharedSettings';
import { getCarsByRef } from 'utils/getCarsByRef';
import { getDirectArticlesInfo } from 'utils/getArtclesInfo';

import Container from 'components/Container';
import TopRefsItem from 'components/TopRefsItem';
import Loader from 'components/Loader';

import styles from './TopRefs.module.scss';
const cx = classNames.bind(styles, stylesSlider);

const TopRefs = ({ contextCountry: { currentCountry } }) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [title, setTitle] = useState(null);
  const settings = getSettings(cx('icon-arrow'));

  const getProductsData = ({ field_vs_short_ref, info }) => {
    const refsPromiseArray = field_vs_short_ref.map((item) =>
      getCarsByRef(item, 0, currentCountry)
    );
    setTitle(info);

    if (field_vs_short_ref.length) {
      axios
        .all(refsPromiseArray)
        .then((totalResponse) => {
          if (!totalResponse.length) return;
          const allProductIds = totalResponse.map((item) => {
            return item.data.data.array[0].articleId;
          });

          getDirectArticlesInfo({
            articleId: {
              array: allProductIds,
            },
            articleCountry: currentCountry,
          })
            .then((articleResponse) => {
              if (articleResponse.data && articleResponse.status === 200) {
                setData(articleResponse.data.data.array);
              }
            })
            .catch(() => {
              setLoading(false);
            })
            .finally(() => {
              setLoading(false);
            });
        })
        .catch(() => {
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    axios({
      method: 'get',
      url:
        backendUrl + langCodeTA + '/block/top-10-new-vs-refs-tecdoc?_format=json',
      headers: {
        ...basicAuth,
      },
    })
      .then((response) => {
        if (response.data && response.status === 200) {
          getProductsData(response.data);
        } else {
          setLoading(false);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <Fragment>
      {!!data && !!data.length ? (
        <section className={cx('root')}>
          <h2 className={cx('section-title')}>{title}</h2>
          <div className={cx('section')}>
            <Container>
              <Slider {...settings} className={cx('listing')}>
                {data.map((item, index) => (
                  <TopRefsItem data={item} key={index} />
                ))}
              </Slider>
            </Container>
          </div>
        </section>
      ) : null}
    </Fragment>
  );
};

export default withCountryContext(withErrorBoundary(TopRefs));



// WEBPACK FOOTER //
// ./src/components/TopRefs/TopRefs.js